// Device and platform detection utilities

export type Platform = 'iOS' | 'Android' | 'Web';

/**
 * Detects if the current device is a mobile platform (iOS or Android)
 * @returns true if iOS or Android, false otherwise
 */
export const getIsMobilePlatform = (): boolean => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

/**
 * Detects the current platform
 * @returns Platform type: 'iOS', 'Android', or 'Web'
 */
export const getPlatform = (): Platform => {
  const userAgent = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'iOS';
  if (/Android/i.test(userAgent)) return 'Android';
  return 'Web';
};

/**
 * Gets the appropriate HelloApp enum value for API registration
 * @returns HelloApp enum string for the backend
 */
export const getAppNameByPhoneType = (): string => {
  const platform = getPlatform();
  return platform === 'iOS'
    ? 'ReactNativeHHIOS'
    : platform === 'Android'
      ? 'ReactNativeHHAndroid'
      : 'ReactNativeHHAndroid';
};

/**
 * Gets the device vendor ID (for web, returns 'web')
 * @returns Vendor ID string
 */
export const vendorID = 'web';

/**
 * Gets the device model from user agent
 * @returns Device model string
 */
export const deviceModel = navigator.userAgent;
